import { TabList, Tab, SelectTabData, SelectTabEvent, mergeClasses } from '@fluentui/react-components';
import { ReactNode, useState } from 'react';
import { isMobile } from 'react-device-detect';

import { useNavigateBarStyles } from './NavigationTabs.styles';

export interface INavigationTabsItem {
  value: string
  name: string
  icon: ReactNode
  component: () => ReactNode
}

interface INavigationTabsProps {
  items: INavigationTabsItem[]
  defaultTab?: string
  callToAction?: JSX.Element | null
}

const NavigationTabs: React.FC<INavigationTabsProps> = ({ items, defaultTab, callToAction }: INavigationTabsProps) => {
  const styles = useNavigateBarStyles();
  const [selectedTab, setSelectedTab] = useState<string>(items?.find(item => item.value === defaultTab)?.value || items[0]?.value || '');
  const tabStyle = mergeClasses('tab-style', styles.tab, isMobile ? '' : styles.tabDeskTop);

  const activeComponent = items.find(item => item.value === selectedTab)?.component;
  const tabRender = items.map((tab: INavigationTabsItem) => {
    return (
      <Tab key={tab.value} className={tabStyle} icon={<span className="tab-icon">{tab.icon}</span>} value={tab.value} role="tab" data-testid={`tab-${tab.name}`}>
        {tab.name}
      </Tab>
    );
  });

  const handleTabSelect = (_event: SelectTabEvent, data: SelectTabData): void => {
    if (typeof data.value === 'string') {
      setSelectedTab(data.value);
    }
  };

  return (
    <div className={styles.container}>
      <TabList vertical selectedValue={selectedTab} className={styles.tabList} onTabSelect={handleTabSelect}>
        {tabRender}
        {callToAction}
      </TabList>

      <div className={styles.contentArea}>
        {activeComponent && activeComponent()}
      </div>
    </div>
  );
};

export default NavigationTabs;
